/**
 * BottomNav — モバイルボトムタブバー (#23: Mobile のみ表示)
 * focus_mode（演習・模試受験中）ではボトムバーを非表示にする。
 * アイコンはインライン SVG (#45)。safe-area 対応（#6 親指リーチ）。
 */

import { NavLink, useLocation } from 'react-router-dom'
import Icon from './Icon'

interface NavItem {
  to: string
  label: string
  icon: React.ComponentProps<typeof Icon>['name']
  testId: string
}

const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'ホーム', icon: 'home', testId: 'nav-home' },
  { to: '/study', label: '学習', icon: 'book', testId: 'nav-study' },
  { to: '/practice', label: '演習', icon: 'pencil', testId: 'nav-practice' },
  { to: '/review', label: '復習', icon: 'refresh', testId: 'nav-review' },
  { to: '/stats', label: '成績', icon: 'chart', testId: 'nav-stats' },
]

// focus_mode routes — ボトムバーを隠す（演習中・模試受験中）
const FOCUS_MODE_ROUTES = ['/practice', '/mock-exam/session']

export default function BottomNav() {
  const location = useLocation()
  const inFocusMode = FOCUS_MODE_ROUTES.some((r) => location.pathname.startsWith(r))

  if (inFocusMode) return null

  return (
    <nav
      aria-label="メインナビゲーション"
      className="fixed inset-x-0 bottom-0 z-[100] flex h-bottom-nav items-center border-t border-border bg-surface pb-[env(safe-area-inset-bottom)] shadow-bottom-nav"
    >
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          data-testid={item.testId}
          className={({ isActive }) =>
            [
              'flex min-h-[44px] flex-1 flex-col items-center justify-center gap-0.5 pt-1 text-[10px] font-semibold transition-colors duration-fast',
              isActive ? 'text-accent' : 'text-text-muted',
            ].join(' ')
          }
        >
          <Icon name={item.icon} size={20} />
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
